import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Fragment } from 'react';
export function Select({ name, labelText, options, defaultValue = '', required, autoFocus, handleInputChange, errors, validateInput, placeholder, }) {
    const hasErrors = Boolean(errors === null || errors === void 0 ? void 0 : errors.length);
    function onChange(e) {
        if (handleInputChange) {
            handleInputChange(e);
        }
        // Only validate on change when there are errors:
        if (hasErrors && validateInput) {
            const el = e.target;
            validateInput(el);
        }
    }
    function onBlur(e) {
        if (validateInput) {
            const el = e.target;
            validateInput(el);
        }
    }
    return (_jsxs("div", Object.assign({ className: "form-field" }, { children: [_jsx("label", Object.assign({ htmlFor: name }, { children: labelText })), _jsxs("select", Object.assign({ className: clsx(hasErrors && 'input-validation-error'), id: name, name: name, required: required, autoFocus: autoFocus, onChange: onChange, onBlur: onBlur, defaultValue: defaultValue, "data-label-text": labelText }, { children: [placeholder && (_jsx("option", Object.assign({ value: "", disabled: true }, { children: placeholder }))), options.map((option) => typeof option === 'string' ? (_jsx("option", Object.assign({ value: option }, { children: option }), option)) : (_jsx("option", Object.assign({ value: option.value || '' }, { children: option.text }), option.value)))] })), hasErrors && (_jsx("div", Object.assign({ className: "field-validation-error" }, { children: errors.map((error) => (_jsxs(Fragment, { children: [error, _jsx("br", {})] }, error))) })))] })));
}
